import Route from '@ember/routing/route';
import { later, cancel } from '@ember/runloop';
import { inject as service } from '@ember/service';

export default class ClassGroupsRoute extends Route
{
	@service ajax

	configTimer = null
	configRefreshInterval = 60000

	async model()
	{
		const config = await this.fetchConfig();
		return { config };
	}

	setupController(controller, model)
	{
		controller.set('event', this.modelFor('event'));
		controller.set('classGroupsConfig', model.config);
	}

	async fetchConfig()
	{
		let config = await this.ajax.request("classGroupsConfig.json");
		return config;
	}

	async fetchConfigLoop()
	{
		cancel(this.configTimer);
		this.configTimer = later(this, async function()
		{
			const config = await this.fetchConfig();
			this.controller.set('classGroupsConfig', config);

			this.fetchConfigLoop();
		}, this.configRefreshInterval);
	}

	activate(transition)
	{
		this.fetchConfigLoop();
	}

	deactivate(transition)
	{
		cancel(this.configTimer);
	}
}
